export default "__VITE_ASSET__DPoBJyIt__"